import React, { useState, useEffect } from "react";
import { Content, Main } from "../../../components/Layout";
import TableResponsive from "../../../components/TableResponsive";
import styleButton from "../../../components/Button/Button.module.css";
import ModalProduct from "../../../components/Modal/modal-product";
import useFormat from "../../../hooks/utils/useFormat";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";

export default function Charges() {
  const { commercial, reload, setreload } = useOutletContext();
  const custom_payment = commercial?.custom_payments.filter(__payment => __payment.payer_type === "formando");
  console.log("custom_payment", custom_payment);
  const [productModal, setproductModal] = useState({
    show: false,
    product_pre_load: null,
  });
  const { formatReal } = useFormat();

  const { setbreadcrumb } = useWrapper();
  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  return (
    <>
      <ModalProduct
        show={productModal.show}
        productPreLoad={productModal.product_pre_load}
        commercial={commercial || []}
        closeModal={() => {
          setproductModal({ show: false, id: null });
        }}
        reload={() => {
          setreload(!reload);
        }}
        isProduct={false}
        payerPreLoad="formando"
      />
      <Main>
        {!commercial ? (
          <Content>
            <Loading />
          </Content>
        ) : (
          <Content>
            <div className="d-flex justify-content-between mb-4">
              <h2 className="form-title">Cobrança Extra</h2>
              <button
                className={styleButton.button_ghost}
                onClick={() => {
                  setproductModal({ show: true, product_pre_load: null });
                }}
              >
                <span>Adicionar Cobrança</span>
              </button>
            </div>
            <TableResponsive
              table={{
                head: [{ data: "Formandos" }, { data: "Produto" }, { data: "Valor" }],
                body:
                  custom_payment?.map(__payment => ({
                    onClick: () => {
                      setproductModal({
                        show: true,
                        product_pre_load: __payment,
                      });
                    },
                    data: [
                      { element: __payment.trainees.name },
                      { element: __payment.name },
                      {
                        element: formatReal(
                          ((__payment.value || 0) + (__payment.contribution_value || 0)) * (__payment.quantity || 0) +
                            (__payment.convenience_fee || 0),
                        ),
                      },
                    ],
                  })) || [],
              }}
            />
          </Content>
        )}
      </Main>
    </>
  );
}
